/** Agent-spine (ADR-003): one run of a journey, pushed at start (running) and end (completed/failed). */
export const journeyExecutionDescriptor = {
    slug: 'journey_execution',
    kind: 'document',
    label: { singular: 'Esecuzione percorso', plural: 'Esecuzioni percorso' },
    table: 'ai_portal_journey_execution',
    idStrategy: 'sha256',
    fields: [
        { name: 'execution_id', type: 'text', label: 'ID esecuzione', required: true, unique: true },
        { name: 'journey_id', type: 'text', label: 'ID percorso', required: true },
        { name: 'trigger_type', type: 'text', label: 'Tipo di avvio' },
        { name: 'triggered_by', type: 'text', label: 'Avviata da' },
        { name: 'status', type: 'text', label: 'Stato' },
        { name: 'context', type: 'json', label: 'Contesto' },
        { name: 'result_summary', type: 'text', label: 'Esito in sintesi' },
        { name: 'error', type: 'text', label: 'Errore' },
        { name: 'started_at', type: 'datetime', label: 'Avviata il', required: true },
        { name: 'completed_at', type: 'datetime', label: 'Completata il' },
    ],
    behaviors: {
        audit: true,
        tenantScoped: true,
    },
    emits: ['journey_execution.completed'],
    ui: { mode: 'generated', icon: 'PlayCircleOutlined', navGroup: 'Agenti', navOrder: 41 },
};
